"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//******************************************************************************
// Copyright 2018-2020, ShareSquared Inc., All Rights Reserved.
//
// Author:  Ted Iverson
// Created: 06/22/2020
//
// The contents of this file are proprietary and considered trade secret.
// Any disclosure outside of its intended use is expressly prohibited.
//******************************************************************************
var React = require("react");
var ReactDOM = require("react-dom");
require("./index.css");
var App_1 = require("./App");
var serviceWorker = require("./serviceWorker");
require("bootstrap/dist/css/bootstrap.min.css");
var Icons_1 = require("@fluentui/react/lib/Icons");
var file_type_icons_1 = require("@uifabric/file-type-icons");
// NOTE: this needs to be done or the icons used by the react UI control
// won't be displayed
Icons_1.initializeIcons();
// this loads the filetype icons so they can be used in the FileType
// results column
file_type_icons_1.initializeFileTypeIcons();
var urlParams = new URLSearchParams(window.location.search);
ReactDOM.render(React.createElement(React.StrictMode, null,
    React.createElement(App_1.default, { InitialTemplateName: urlParams.has("id") ? urlParams.get("id") : "" })), document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
//# sourceMappingURL=index.js.map